import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { SiteInteractionsService, siteSiteInteractionsService } from './siteInteractionsService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(siteSiteInteractionsService)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(SiteInteractionsService)
}
